export default {
	APP_CODE: "web_portal",
	SIDEBAR_TITLE: import.meta.env.VITE_SIDEBAR_TITLE,
	BACKEND_ENDPOINT: import.meta.env.VITE_BACKEND_ENDPOINT,
	BACKEND_FILE_ENDPOINT: import.meta.env.VITE_BACKEND_FILE_ENDPOINT,
	MARKETPLACE_ENDPOINT: import.meta.env.VITE_MARKETPLACE_ENDPOINT,
	ENABLE_TANSTACK_DEVTOOLS: import.meta.env.VITE_ENABLE_TANSTACK_DEVTOOLS === "true",
};

// This portal runs on the webcore app code; permissions are scoped to it.
export function getActiveAppCode(): string {
	return "web_portal";
}
